import {
    CFooterDescripition,
    CFooterNewsletter,
    CFooterPayments,
    CFooterPaymentsCol,
    CWidgetTitle,
    CContactInfoLabel
} from './styled'

export default {
    'footer-company-description': CFooterDescripition,
    'footer-newsletter': CFooterNewsletter,
    'footer-payments': CFooterPayments,
    'footer-payments-col': CFooterPaymentsCol,
    'widget-title': CWidgetTitle,
    'contact-info-label': CContactInfoLabel
}